module.exports = __webpack_public_path__ + "static/media/promo.fc982a41.png";